import { Observable } from 'rxjs';

import { UseCase } from '../../base/use-case';

import {
  ContentAcademyModel,
  DataContentAcademyModel,
} from '../../models/academy/content-academy.model';

import { AcademyRepository } from '../../repositories/academy.repository';

export class UpdateContentAcademyUseCase implements UseCase<
  DataContentAcademyModel,
  ContentAcademyModel
> {
  constructor(private repository: AcademyRepository) {}

  execute(params: DataContentAcademyModel): Observable<ContentAcademyModel> {
    return this.repository.updateContentAcademy(params);
  }
}
